var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.81 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.39,6.9c1.71,0,3.11,1.01,3.3,2.38h1.44c-.3-2.1-2.3-3.62-4.74-3.62C2.61,5.66,0,7.52,0,11.39s2.59,5.73,5.39,5.73c2.48,0,4.48-1.52,4.72-3.62h-1.41c-.16,1.38-1.57,2.38-3.31,2.38-2.34,0-3.99-1.58-3.99-4.5s1.65-4.5,3.99-4.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.78,
    y: 5.62,
    width: 1.28,
    height: 11.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.87,8.8c-2.39,0-4.1,1.73-4.1,4.16s1.71,4.16,4.1,4.16,4.11-1.74,4.11-4.16-1.71-4.16-4.11-4.16Zm0,7.17c-1.65,0-2.79-1.25-2.79-3.01s1.14-3.01,2.79-3.01,2.8,1.25,2.8,3.01-1.14,3.01-2.8,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.58,11.04c0-.7,.62-1.15,1.57-1.15,.74,0,1.75,.35,1.86,1.38h1.25c-.1-1.49-1.3-2.46-3.07-2.46s-2.85,.9-2.85,2.26c0,3.49,4.69,1.33,4.69,3.73,0,.66-.67,1.22-1.68,1.22-1.17,0-1.87-.56-1.99-1.6h-1.23c.13,1.68,1.34,2.72,3.22,2.72,1.78,0,2.96-.93,2.96-2.37,0-3.7-4.72-1.54-4.72-3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.52,15.99c-1.52,0-2.62-1.18-2.72-2.85h6.31c.02-.11,.03-.38,.03-.56,0-2.14-1.41-3.78-3.76-3.78s-3.84,1.75-3.84,4.11,1.6,4.21,3.99,4.21c2,0,3.43-1.07,3.7-2.72h-1.3c-.26,1.01-1.09,1.58-2.4,1.58Zm-.14-6.1c1.44,0,2.35,.86,2.45,2.22h-4.96c.24-1.42,1.15-2.22,2.51-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.81,0c-5.51,0-10,4.48-10,10s4.49,10,10,10,10-4.49,10-10S63.33,0,57.81,0Zm0,18c-4.41,0-8-3.59-8-8s3.59-8,8-8,8,3.59,8,8-3.59,8-8,8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.28 6.73 60.87 5.32 57.71 8.48 54.75 5.52 53.33 6.94 56.29 9.9 53.13 13.06 54.54 14.47 57.71 11.31 61.07 14.68 62.49 13.26 59.12 9.9 62.28 6.73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fc48006b7162a004ba90f253f09f2983.svg";
export { ForwardRef as ReactComponent };